/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Remote } from './remote';

export interface Device {
    deviceId?: string;
    deviceType?: Device.DeviceTypeEnum;
    fingerprint?: string;
    freeStorageSpace?: number;
    hostname?: string;
    /**
     * The database ID
     */
    id?: string;
    ipAddress?: string;
    latitude?: number;
    /**
     * This date is set server side to make the object available or not for the next Sync
     */
    localUpdateDate?: Date;
    longitude?: number;
    macAddress?: string;
    os?: string;
    osRelease?: string;
    player?: Remote;
    publicIpAddress?: string;
    /**
     * this date is set server side when the object is updated from the app
     */
    remoteUpdateDate?: Date;
    screenHeight?: number;
    screenWidth?: number;
    totalStorageSpace?: number;
    touch?: boolean;
}
export namespace Device {
    export type DeviceTypeEnum = 'MOBILE' | 'TABLET' | 'DESKTOP' | 'BOX';
    export const DeviceTypeEnum = {
        MOBILE: 'MOBILE' as DeviceTypeEnum,
        TABLET: 'TABLET' as DeviceTypeEnum,
        DESKTOP: 'DESKTOP' as DeviceTypeEnum,
        BOX: 'BOX' as DeviceTypeEnum
    };
}
